import request from '@/utils/request'

// 获取料号列表
export const getMaterialBatches = (params) => {
  return request({
    url: '/api/material-batches',
    method: 'get',
    params
  })
}

// 获取单个料号详情
export const getMaterialBatch = (id) => {
  return request({
    url: `/api/material-batches/${id}`,
    method: 'get'
  })
}

// 快捷入库：根据料号解析可绑定的采购单号、加工单号（无关联则不应走对应入库路径）
export const getMaterialBatchQuickInboundHints = (batchId, params = {}) => {
  return request({
    url: `/api/material-batches/${batchId}/quick-inbound-hints`,
    method: 'get',
    params
  })
}

// 创建料号
export const createMaterialBatch = (data) => {
  return request({
    url: '/api/material-batches',
    method: 'post',
    data
  })
}

// 更新料号
export const updateMaterialBatch = (id, data) => {
  return request({
    url: `/api/material-batches/${id}`,
    method: 'put',
    data
  })
}

// 删除料号
export const deleteMaterialBatch = (id) => {
  return request({
    url: `/api/material-batches/${id}`,
    method: 'delete'
  })
}

// 下载批量创建料号模板
export const downloadBatchCreateTemplate = () => {
  return request({
    url: '/api/material-batches/batch-create-template',
    method: 'get',
    responseType: 'blob'
  })
}

// 解析Excel文件（批量创建料号）
export const parseExcelForBatchCreate = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/material-batches/parse-excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 批量创建料号
export const batchCreateMaterialBatches = (data) => {
  return request({
    url: '/api/material-batches/batch-create',
    method: 'post',
    data,
    timeout: 60000 // 60秒超时，批量操作可能需要更长时间
  })
}

// 切换料号状态
export const toggleMaterialBatchStatus = (id, data) => {
  return request({
    url: `/api/material-batches/${id}/status`,
    method: 'patch',
    data
  })
}

// 智能搜索料号 - 修正：使用正确的端点
export const searchMaterialBatches = (params) => {
  // 注意：后端没有独立的/search端点，我们使用普通的getMaterialBatches
  // 但搜索功能已经集成在getMaterialBatches中
  return request({
    url: '/api/material-batches',
    method: 'get',
    params
  })
}

// 获取下一个仓库料号数字
export const getNextWarehouseNumber = (params) => {
  return request({
    url: '/api/material-batches/next-warehouse-number',
    method: 'get',
    params
  })
}

// 获取料号搜索建议
export const getBatchSuggestions = (params) => {
  return request({
    url: '/api/material-batches/search/suggestions',
    method: 'get',
    params
  })
}

// 生成系统料号
export const generateSystemBatchNumber = (data) => {
  return request({
    url: '/api/material-batches/generate-system-number',
    method: 'post',
    data
  })
}

// 清空料号
export const clearMaterialBatch = (id, operationPassword) => {
  const config = {
    url: `/api/material-batches/${id}/clear`,
    method: 'post',
  }
  if (operationPassword) {
    config.data = { operation_password: operationPassword }
  }
  return request(config)
}

// 重置系统料号
export const resetMaterialBatchSystemNumber = (id, operationPassword) => {
  const config = {
    url: `/api/material-batches/${id}/reset-system-number`,
    method: 'post',
  }
  if (operationPassword) {
    config.data = { operation_password: operationPassword }
  }
  return request(config)
}

/** 超级权限：料号重绑材料身份（有库存亦可），详见后端 confirm 规则 */
export const superRelinkMaterialBatchIdentity = (batchId, data) => {
  return request({
    url: `/api/material-batches/${batchId}/super-relink-identity`,
    method: 'post',
    data
  })
}